import { Layout, Menu, theme } from 'antd';
import React, { memo, useEffect, useState } from 'react';
import useItems from './items';
import { useLocation } from 'react-router-dom';

const SideBar = ({ collapsed, handleCollapsed }) => {
  const { token } = theme.useToken();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const { pathname } = useLocation();
  const menuItems = useItems();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
      // Only auto-collapse on smaller screens
      if (window.innerWidth <= 576 && !collapsed) {
        handleCollapsed(true);
      }
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [collapsed, handleCollapsed]);

  useEffect(() => {
    if (!menuItems || menuItems.length === 0) return;
    
    const index = menuItems.findIndex(
      ({ path, children }) =>
        path === pathname ||
        children?.some(({ path: childPath }) => childPath === pathname)
    );
    if (index >= 0) {
      setSelectedKeys([menuItems[index].key]);
      if (menuItems[index].children) {
        const childIndex = menuItems[index].children?.findIndex(
          child => child.path === pathname
        );
        if (childIndex >= 0) {
          setSelectedKeys([menuItems[index].children[childIndex].key]);
          setOpenKeys([menuItems[index].key]);
        }
      }
    }
  }, [menuItems, pathname]);

  return (
    <Layout.Sider
      theme="light"
      collapsible
      breakpoint="lg"
      collapsed={collapsed}
      onCollapse={handleCollapsed}
      width={isMobile ? 240 : token.Layout.siderWidth}
      collapsedWidth={0}
      style={{
        position: 'fixed',
        top: token.Layout.headerHeight,
        left: 0,
        bottom: 0,
        overflow: 'auto',
        height: `calc(100vh - ${token.Layout.headerHeight}px)`,
        zIndex: 1000,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s ease',
        transform: collapsed ? 'translateX(-100%)' : 'translateX(0)'
      }}
    >
      <Menu
        theme="light"
        mode="inline"
        items={menuItems}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={keyOpened => {
          setOpenKeys(keyOpened);
        }}
        style={{
          borderRight: 'none'
        }}
      />
    </Layout.Sider>
  );
};

export default memo(SideBar);
